import { Model } from '@vuex-orm/core'

export default class Customer extends Model {
  static entity = 'customer'
  static primaryKey = '_id'

  static fields () {
    return {
      _id: this.attr(null),
      icon: this.attr(''),
      colors: this.attr({
        primary: '',
        secondary: ''
      })
    }
  }
}

export class CustomerRecord extends Customer {
  static entity = 'administration:customer'
  static fields () {
    return {
      ...super.fields(),
      settings: this.attr({...new Settings()}),
      name: this.string(''),
      contactEmail: this.string('')
    }
  }

  static defaults () {
    return {}
  }
}

class Settings {
  constructor () {
    this.language = ''
    this.contract = {
      questionaireLimit: null,
      enabledLanguages: null,
      packageType: null,
      userLimit: null
    }
    this.dashboard = {
      questionnaire: null
    }
  }
}
